import { useEffect, useState } from 'react';

export function useStaggeredReveal(total: number, gapMs: number): number {
  const [shown, setShown] = useState(() => Math.min(total, 1));

  useEffect(() => {
    if (total === 0 || shown >= total) return;
    if (shown === 0) {
      setShown(1);
      return;
    }
    const timer = window.setTimeout(() => setShown(prev => prev + 1), gapMs);
    return () => window.clearTimeout(timer);
  }, [shown, total, gapMs]);

  return Math.min(shown, total);
}
